import React from "react";

import { IPageProps } from "./Components/Pages/IPageProps";

import { HomePage } from "./Components/Pages/Home";
import { LoginPage } from "./Components/Pages/Login";
import { SignUpPage } from "./Components/Pages/SignUp";
import { AccountPage } from "./Components/Pages/Account";
import { DownloadPage } from "./Components/Pages/Download";
import { QuiltBotPage } from "./Components/Pages/QuiltBot";
import { QuiltCodePage } from "./Components/Pages/QuiltCode";
import { FavoritesPage } from "./Components/Pages/Favorites";
import { ForgotPasswordPage } from "./Components/Pages/ForgotPassword";

export interface IRoute {
    readonly name: string;
    readonly path: string;

    readonly Page: React.ComponentType<IPageProps>
}

export const HomeRoute: IRoute = {
    name: "Home",
    path: "/",

    Page: HomePage
};

export const AccountRoute: IRoute = {
    name: "Account",
    path: "/account",

    Page: AccountPage
};

export const FavoritesRoute: IRoute = {
    name: "Favorites",
    path: "/favorites",

    Page: FavoritesPage
};

export const QuiltBotRoute: IRoute = {
    name: "Quilt Bot",
    path: "/quiltbot",

    Page: QuiltBotPage
};

export const LoginRoute: IRoute = {
    name: "",
    path:"/login",

    Page: LoginPage
};

export const SignUpRoute: IRoute = {
    name: "",
    path:"/signup",

    Page: SignUpPage
};

export const ForgotPasswordRoute: IRoute = {
    name: "",
    path: "/forgotpassword",

    Page: ForgotPasswordPage
}

export const DownloadRoute: IRoute = {
    name: "",
    path: "/download",

    Page: DownloadPage
}

export const Routes: IRoute[] = [
    {
        name: "",
        path:"/q/:quiltCode",

        Page: QuiltCodePage
    },

    LoginRoute,
    SignUpRoute,
    AccountRoute,
    ForgotPasswordRoute,

    FavoritesRoute,

    QuiltBotRoute,

    DownloadRoute,

    HomeRoute
];